import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/landingpage.css';
import Home from '../assets/Home.png'
import Calendar from '../assets/Calendar.png'
import TradeSummary from '../assets/TradeSummary.png'
import Journal from '../assets/Journal.png'
import Leaderboard from '../assets/Leaderboard2.png'
import Study from '../assets/Study.png'
import Insights from '../assets/Insights.png'
import Analytics from '../assets/Analytics.png'
import AIChat from '../assets/AIChat.png'
import Groups from '../assets/Groups.png'
import HomeLight from '../assets/Home-Light.png'
import CalendarLight from '../assets/Calendar-Light.png'
import TradeSummaryLight from '../assets/TradeSummary-Light.png'
import JournalLight from '../assets/Journal-Light.png'
import LeaderboardLight from '../assets/Leaderboard2-Light.png'
import StudyLight from '../assets/Study-Light.png'
import InsightsLight from '../assets/Insights-Light.png'
import AnalyticsLight from '../assets/Analytics-Light.png'
import AIChatLight from '../assets/AIChat-Light.png'
import GroupsLight from '../assets/Groups-Light.png'

import {
  Flex,
  Text,
  Icon,
  IconButton,
  Heading,
  useColorMode,
  Box,
  Image,
  Link,
  HStack,
  VStack,
  Stack,
  SimpleGrid,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  List,
  ListItem,
  ListIcon,
  Badge
} from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon, CheckCircleIcon } from "@chakra-ui/icons";
import { HiOutlineMail } from "react-icons/hi";
import { BsFilePersonFill, BsCalendarEvent, BsJournal, BsGraphUp, BsChatDots } from "react-icons/bs";
import { IoAnalyticsSharp, IoStatsChart } from "react-icons/io5";
import { FiMonitor } from "react-icons/fi";
import { RiStockFill } from "react-icons/ri";
import { ImListNumbered } from "react-icons/im";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdOutlineInsights } from "react-icons/md";

const features = [
  {
    label: 'Summary Page',
    title: 'Summary Page',
    lightImg: HomeLight,
    darkImg: Home,
    alt: 'Home Screen',
    icon: IoAnalyticsSharp,
    shortDesc: 'Overview of trading activity and account stats',
    description: 'Your home base for tracking performance. View key stats, account balance history, and filter results by time or value.',
  },
  {
    label: 'Trade Management',
    title: 'Trade Management',
    lightImg: TradeSummaryLight,
    darkImg: TradeSummary,
    alt: 'Trade Summary Screen',
    icon: FiMonitor,
    shortDesc: 'Log, import, edit and manage your trades',
    description: 'Log trades manually or import via CSV. Edit, filter, and manage all your entries in one place.',
  },
  {
    label: 'Calendar View',
    title: 'Calendar View',
    lightImg: CalendarLight,
    darkImg: Calendar,
    alt: 'PnL Calendar',
    icon: BsCalendarEvent,
    shortDesc: 'Visualize daily, weekly and monthly P&L',
    description: 'See your P&L on a daily, weekly, and monthly calendar view. Click any day to drill into the trades closed that session.',
  },
  {
    label: 'Journal',
    title: 'Journal',
    lightImg: JournalLight,
    darkImg: Journal,
    alt: 'Journal Screen',
    icon: BsJournal,
    shortDesc: 'Strategize and save thoughts, links and photos',
    description: 'A rich-text editor for daily notes, strategies, and reflections. Attach links and images to any entry.',
  },
  {
    label: 'Study',
    title: 'Study',
    lightImg: StudyLight,
    darkImg: Study,
    alt: 'Study Desk',
    icon: BsGraphUp,
    shortDesc: 'Annotate charts and track tickers',
    description: 'Annotate charts, take per-ticker notes, and curate a watchlist with an embedded TradingView chart — your personal study desk.',
  },
  {
    label: 'Insights',
    title: 'Insights',
    lightImg: InsightsLight,
    darkImg: Insights,
    alt: 'Insights Dashboard',
    icon: MdOutlineInsights,
    shortDesc: 'Unified analytics hub',
    description: 'Trade reviews, risk/reward, journal trends, account value, options stats, and tag performance — every signal in one screen.',
  },
  {
    label: 'Analytics',
    title: 'Analytics Suite',
    lightImg: AnalyticsLight,
    darkImg: Analytics,
    alt: 'Analytics Suite',
    icon: IoStatsChart,
    shortDesc: 'Slice P&L by ticker, tag, emotion, or DTE',
    description: 'Break down performance by ticker, custom tag, emotional state, or options DTE bucket. Find the patterns behind your edge.',
  },
  {
    label: 'Ask My Journal',
    title: 'Ask My Journal',
    lightImg: AIChatLight,
    darkImg: AIChat,
    alt: 'AI Chat',
    icon: BsChatDots,
    shortDesc: 'AI-powered Q&A over your trades',
    description: 'Talk to your trades. Natural-language Q&A over your full trade history and journal entries, with grounded citations.',
  },
  {
    label: 'Leaderboard',
    title: 'Leaderboard',
    lightImg: LeaderboardLight,
    darkImg: Leaderboard,
    alt: 'Leaderboard Screen',
    icon: ImListNumbered,
    shortDesc: 'Compare your performance against other traders',
    description: 'Rank against other traders by total P&L, win rate, and more. Go private anytime from User Preferences.',
  },
  {
    label: 'Groups',
    title: 'Groups',
    lightImg: GroupsLight,
    darkImg: Groups,
    alt: 'Groups',
    icon: HiOutlineUserGroup,
    shortDesc: 'Create or join trading groups',
    description: 'Team up with other traders. Share stats, compare performance, and hold each other accountable.',
  },
];

const faqs = [
  {
    q: 'Is MyTradingTracker free?',
    a: 'You get a 5-day free trial with full access to every feature (with limited AI requests). After that, a one-time $5 payment unlocks unlimited lifetime access — no subscriptions, no recurring charges.',
  },
  {
    q: 'How do I import my trades?',
    a: 'Manual entry, CSV import (with an AI-assisted fixer for malformed files), or one trade at a time. Most major broker exports work out of the box.',
  },
  {
    q: 'Is my trading data private?',
    a: 'Yes. Your data is yours. Public profiles and the leaderboard are opt-in — toggle them off in User Preferences and your account stays fully private.',
  },
  {
    q: 'What does Ask My Journal actually do?',
    a: "It's an AI assistant that answers natural-language questions about your trade history and journal entries with grounded citations. Ask “What's my win rate on AAPL when I'm calm?” and get a real answer.",
  },
  {
    q: 'Can I use this for options trading?',
    a: 'Yes. The Options Analytics view buckets win rate and P&L by Days-to-Expiry (0DTE, weekly, monthly, 30+) and the trade log captures contract-level details.',
  },
  {
    q: 'Do I need to bring my own OpenAI key?',
    a: 'No. AI features are included — limited during the free trial, unlimited after the $5 lifetime upgrade.',
  },
  {
    q: 'Can I cancel?',
    a: "There's nothing to cancel. The $5 is a one-time payment, not a subscription.",
  },
];

export default function LandingPage() {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  const words = ['tracker', 'journal', 'dashboard', 'analyzer', 'edge', 'companion', 'playbook', 'hub', 'copilot', 'toolkit', 'logbook', 'assistant', 'scorecard', 'command center', 'wingman', 'AI assistant', 'study desk', 'insight engine', 'review system'];
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');

  useEffect(() => {
    const type = () => {
      const currentWord = words[wordIndex];
      if (isDeleting) {
        if (charIndex === 0) {
          setIsDeleting(false);
          setWordIndex((prevWordIndex) => (prevWordIndex + 1) % words.length);
        } else {
          setText(currentWord.substring(0, charIndex));
          setCharIndex((prevCharIndex) => prevCharIndex - 1);
        }
      } else {
        setText(currentWord.substring(0, charIndex));
        if (charIndex === currentWord.length) {
          setIsDeleting(true);
        } else {
          setCharIndex((prevCharIndex) => prevCharIndex + 1);
        }
      }
    };

    const typingDelay = isDeleting ? 100 : 250;
    const nextTyping = setTimeout(type, typingDelay);
    return () => clearTimeout(nextTyping);
  }, [text, charIndex, isDeleting, wordIndex, words]);

  useEffect(() => {
    const nextWordDelay = setTimeout(() => {
      if (isDeleting) {
        setCharIndex(words[wordIndex].length);
      }
    }, 1000);
    return () => clearTimeout(nextWordDelay);
  }, [isDeleting]);

  const [tabIndex, setTabIndex] = useState(0);

  const handleAnchorClick = (event, id, index) => {
    event.preventDefault();
    const element = document.getElementById(id);
    setTabIndex(index);
    element.scrollIntoView({ behavior: 'smooth' });
  };

  const footerTextColor = colorMode === 'light' ? 'white' : 'gray.800';

  return (
    <Flex
      direction="column"
      bg={colorMode === 'light' ? 'gray.200' : 'gray.800'}
      minH="100vh"
    >
      <VStack flex="1" overflowY="auto" spacing={0}>

        {/* Hero Section */}
        <Stack
          direction={{ base: 'column', md: 'row' }}
          align="center"
          pt={{ base: 8, md: 12 }}
          pb={{ base: 6, md: 10 }}
          px={{ base: '5%', md: '10%', lg: '15%' }}
          spacing={{ base: 4, md: 8 }}
        >
          <Heading
            className="landing-heading"
            color={colorMode === 'light' ? 'gray.600' : 'gray.200'}
            w={{ base: '100%', md: '50%' }}
          >
            your personal <br /> trading {text}|
          </Heading>
          <Text
            as='samp'
            className="landing-hero-text"
            color={colorMode === 'light' ? 'gray.600' : 'gray.200'}
            w={{ base: '100%', md: '50%' }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            Log trades, track P&L, journal your setups, and analyze performance by ticker, tag, or emotion — all in one place.
            <Box as="span" display="flex" justifyContent="center" py={3}>
              <Icon fontSize="lg" as={RiStockFill} />
            </Box>
            Import via CSV or log manually. Surface patterns with the Insights dashboard, sharpen your edge with the Study desk, and ask your full journal anything with the built-in AI assistant.
          </Text>
        </Stack>

        {/* Feature Carousel */}
        <Box
          id="tab-panels"
          scrollMarginTop="80px"
          w={{ base: '95%', md: '70%', lg: '55%' }}
          pb={{ base: 12, md: 20 }}
        >
          <Flex align="center" justify="center" gap={{ base: 2, md: 4 }}>
            {/* Left Arrow */}
            <IconButton
              icon={<ChevronLeftIcon boxSize={6} />}
              aria-label="Previous feature"
              variant="ghost"
              size="lg"
              rounded="full"
              color={colorMode === 'light' ? 'gray.600' : 'gray.300'}
              _hover={{ bg: colorMode === 'light' ? 'gray.300' : 'gray.600' }}
              onClick={() => setTabIndex((prev) => (prev - 1 + features.length) % features.length)}
            />

            {/* Card */}
            <Box
              maxW="650px"
              w="100%"
              rounded="lg"
              boxShadow="2px 4px 4px rgba(0,0,0,0.2)"
              bg={colorMode === 'light' ? 'whiteAlpha.900' : 'gray.700'}
              overflow="hidden"
            >
              {features[tabIndex].lightImg ? (
                <Image
                  src={colorMode === 'light' ? features[tabIndex].lightImg : features[tabIndex].darkImg}
                  alt={features[tabIndex].alt}
                  w="100%"
                  borderTopRadius="lg"
                />
              ) : (
                <Flex
                  justify="center"
                  align="center"
                  h="200px"
                  bg={colorMode === 'light' ? 'blue.50' : 'gray.600'}
                  borderTopRadius="lg"
                >
                  <Icon as={features[tabIndex].icon} boxSize={16} color={colorMode === 'light' ? 'blue.400' : 'blue.200'} />
                </Flex>
              )}
              <VStack align="center" p={5} spacing={2}>
                <Heading size="sm">{features[tabIndex].title}</Heading>
                <Text as='samp' fontSize="sm" textAlign="center" whiteSpace="pre-line">
                  {features[tabIndex].description}
                </Text>
              </VStack>
            </Box>

            {/* Right Arrow */}
            <IconButton
              icon={<ChevronRightIcon boxSize={6} />}
              aria-label="Next feature"
              variant="ghost"
              size="lg"
              rounded="full"
              color={colorMode === 'light' ? 'gray.600' : 'gray.300'}
              _hover={{ bg: colorMode === 'light' ? 'gray.300' : 'gray.600' }}
              onClick={() => setTabIndex((prev) => (prev + 1) % features.length)}
            />
          </Flex>

          {/* Dot Indicators */}
          <HStack justify="center" mt={4} spacing={2}>
            {features.map((_, i) => (
              <Box
                key={i}
                w={tabIndex === i ? '20px' : '8px'}
                h="8px"
                rounded="full"
                bg={tabIndex === i
                  ? (colorMode === 'light' ? 'blue.500' : 'blue.200')
                  : (colorMode === 'light' ? 'gray.400' : 'gray.500')
                }
                cursor="pointer"
                transition="all 0.2s"
                onClick={() => setTabIndex(i)}
              />
            ))}
          </HStack>

          {/* Page counter */}
          <Text textAlign="center" mt={2} fontSize="xs" color={colorMode === 'light' ? 'gray.500' : 'gray.400'}>
            {tabIndex + 1} / {features.length}
          </Text>
        </Box>

        {/* Footer */}
        <Box as="footer" w="100%" bg={colorMode === 'light' ? 'blue.500' : 'blue.200'}>

          {/* Section A: Interactive Feature Grid */}
          <VStack id="features-grid" scrollMarginTop="80px" spacing={6} py={10} px={{ base: 4, md: 8 }}>
            <Heading size="md" color={footerTextColor} fontFamily="'Open Sans', sans-serif">
              Our Features
            </Heading>
            <SimpleGrid columns={{ base: 2, sm: 3, md: 3 }} spacing={4} w="100%" maxW="800px">
              {features.map((feature, i) => (
                <Box
                  key={i}
                  bg={colorMode === 'light' ? 'whiteAlpha.200' : 'blackAlpha.200'}
                  rounded="lg"
                  p={4}
                  cursor="pointer"
                  transition="all 0.2s"
                  _hover={{
                    transform: 'scale(1.03)',
                    boxShadow: 'lg',
                    bg: colorMode === 'light' ? 'whiteAlpha.300' : 'blackAlpha.300',
                  }}
                  onClick={(e) => handleAnchorClick(e, 'tab-panels', i)}
                  textAlign="center"
                >
                  <Icon as={feature.icon} boxSize={6} color={footerTextColor} mb={2} />
                  <Text fontWeight="bold" fontSize="sm" color={footerTextColor}>
                    {feature.label}
                  </Text>
                  <Text as='samp' fontSize="xs" color={footerTextColor} opacity={0.85}>
                    {feature.shortDesc}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </VStack>

          {/* Section B: Pricing */}
          <Box
            id="pricing"
            scrollMarginTop="80px"
            px={{ base: 4, md: 8 }}
            py={10}
            borderTopWidth="1px"
            borderColor={colorMode === 'light' ? 'whiteAlpha.300' : 'blackAlpha.300'}
          >
            <VStack spacing={2} mb={6}>
              <Heading size="md" color={footerTextColor} fontFamily="'Open Sans', sans-serif">
                Simple pricing. Stupidly cheap.
              </Heading>
              <Text as='samp' color={footerTextColor} fontSize="sm" opacity={0.9} textAlign="center">
                Start free. Upgrade once. Never pay again.
              </Text>
            </VStack>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} w="100%" maxW="800px" mx="auto">
              <Box
                bg={colorMode === 'light' ? 'whiteAlpha.200' : 'blackAlpha.200'}
                rounded="lg"
                p={6}
                borderWidth="1px"
                borderColor={colorMode === 'light' ? 'whiteAlpha.400' : 'blackAlpha.400'}
              >
                <VStack align="start" spacing={3}>
                  <Text fontWeight="bold" color={footerTextColor} fontSize="lg">
                    Free Trial
                  </Text>
                  <HStack spacing={1} align="baseline">
                    <Heading size="xl" color={footerTextColor}>$0</Heading>
                    <Text as='samp' color={footerTextColor} fontSize="sm" opacity={0.85}>for 5 days</Text>
                  </HStack>
                  <List spacing={2} color={footerTextColor} fontSize="sm">
                    <ListItem><ListIcon as={CheckCircleIcon} />Full access to every feature</ListItem>
                    <ListItem><ListIcon as={CheckCircleIcon} />Unlimited trades, journal, analytics</ListItem>
                    <ListItem><ListIcon as={CheckCircleIcon} />Limited AI requests</ListItem>
                    <ListItem><ListIcon as={CheckCircleIcon} />No credit card required</ListItem>
                  </List>
                  <Button
                    size="sm"
                    colorScheme="whiteAlpha"
                    variant="solid"
                    w="100%"
                    mt={2}
                    onClick={() => navigate('/signup')}
                  >
                    Start free trial
                  </Button>
                </VStack>
              </Box>
              <Box
                bg={colorMode === 'light' ? 'whiteAlpha.300' : 'blackAlpha.300'}
                rounded="lg"
                p={6}
                borderWidth="2px"
                borderColor={colorMode === 'light' ? 'white' : 'gray.800'}
                position="relative"
              >
                <Badge
                  position="absolute"
                  top={3}
                  right={3}
                  colorScheme="yellow"
                  variant="solid"
                  fontSize="xx-small"
                >
                  BEST VALUE
                </Badge>
                <VStack align="start" spacing={3}>
                  <Text fontWeight="bold" color={footerTextColor} fontSize="lg">
                    Lifetime
                  </Text>
                  <HStack spacing={1} align="baseline">
                    <Heading size="xl" color={footerTextColor}>$5</Heading>
                    <Text as='samp' color={footerTextColor} fontSize="sm" opacity={0.85}>one-time</Text>
                  </HStack>
                  <List spacing={2} color={footerTextColor} fontSize="sm">
                    <ListItem><ListIcon as={CheckCircleIcon} />Everything in Free Trial</ListItem>
                    <ListItem><ListIcon as={CheckCircleIcon} />Unlimited AI requests, forever</ListItem>
                    <ListItem><ListIcon as={CheckCircleIcon} />All future features included</ListItem>
                    <ListItem><ListIcon as={CheckCircleIcon} />No subscription. Pay once.</ListItem>
                  </List>
                  <Button
                    size="sm"
                    colorScheme="yellow"
                    variant="solid"
                    w="100%"
                    mt={2}
                    onClick={() => navigate('/signup')}
                  >
                    Get lifetime access
                  </Button>
                </VStack>
              </Box>
            </SimpleGrid>
          </Box>

          {/* Section C: FAQ */}
          <Box
            id="faq"
            scrollMarginTop="80px"
            px={{ base: 4, md: 8 }}
            py={10}
            borderTopWidth="1px"
            borderColor={colorMode === 'light' ? 'whiteAlpha.300' : 'blackAlpha.300'}
          >
            <Heading
              size="md"
              color={footerTextColor}
              fontFamily="'Open Sans', sans-serif"
              textAlign="center"
              mb={6}
            >
              Frequently Asked Questions
            </Heading>
            <Box maxW="800px" mx="auto">
              <Accordion allowToggle>
                {faqs.map((item, i) => (
                  <AccordionItem
                    key={i}
                    borderColor={colorMode === 'light' ? 'whiteAlpha.400' : 'blackAlpha.400'}
                  >
                    <AccordionButton _hover={{ bg: colorMode === 'light' ? 'whiteAlpha.200' : 'blackAlpha.200' }}>
                      <Box as="span" flex="1" textAlign="left" fontWeight="bold" color={footerTextColor} fontSize="sm">
                        {item.q}
                      </Box>
                      <AccordionIcon color={footerTextColor} />
                    </AccordionButton>
                    <AccordionPanel pb={4}>
                      <Text as='samp' color={footerTextColor} fontSize="sm" opacity={0.9}>
                        {item.a}
                      </Text>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </Box>
          </Box>

          {/* Section D: About */}
          <Box
            id="about"
            scrollMarginTop="80px"
            px={{ base: 4, md: 8 }}
            py={5}
            borderTopWidth="1px"
            borderColor={colorMode === 'light' ? 'whiteAlpha.300' : 'blackAlpha.300'}
          >
            <Text fontWeight="bold" color={footerTextColor} fontSize="sm" mb={2}>
              About
            </Text>
            <Text as='samp' color={footerTextColor} fontSize="sm" opacity={0.9}>
              MyTradingTracker is a trading platform built for traders of all experience levels. Log trades manually or import via CSV, then track P&L on a visual calendar and dive into analytics broken down by ticker, custom tag, emotional state, or options DTE bucket. The Insights dashboard pulls every signal — risk/reward, plan adherence, account value over time — into one screen, while the Study desk lets you annotate TradingView charts and keep per-ticker notes. Use the rich-text journal to document strategies and screenshots, then ask the built-in AI assistant anything about your trades. Create or join groups, compete on the public leaderboard, and review every trade with the structured post-trade workflow. Everything lives in one dashboard — no scattered spreadsheets, no switching between tools.
            </Text>
          </Box>

          {/* Section C: Legal + Contact Bar */}
          <Flex
            px={{ base: 4, md: 8 }}
            py={4}
            borderTopWidth="1px"
            borderColor={colorMode === 'light' ? 'whiteAlpha.300' : 'blackAlpha.300'}
            direction={{ base: 'column', md: 'row' }}
            align={{ base: 'start', md: 'center' }}
            justify="space-between"
            gap={3}
          >
            <Text color={footerTextColor} fontSize="xs">
              &copy; 2025 MyTradingTracker |{' '}
              <Link href="/legal/MyTradingTracker_Terms_and_Conditions.pdf" isExternal>
                Terms and Conditions
              </Link>{' '}
              |{' '}
              <Link href="/legal/MyTradingTracker_Privacy_Policy.pdf" isExternal>
                Privacy Policy
              </Link>
            </Text>
            <HStack spacing={4}>
              <HStack spacing={1}>
                <Icon as={HiOutlineMail} color={footerTextColor} boxSize={3} />
                <Link href="mailto:mytradingtrackerapp@gmail.com" color={footerTextColor} fontSize="xs">
                  mytradingtrackerapp@gmail.com
                </Link>
              </HStack>
              <HStack spacing={1}>
                <Icon as={BsFilePersonFill} color={footerTextColor} boxSize={3} />
                <Text as='samp' color={footerTextColor} fontSize="xs" opacity={0.9}>
                  Social Media: Coming Soon!
                </Text>
              </HStack>
            </HStack>
          </Flex>
        </Box>

      </VStack>
    </Flex>
  )
}
